import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'programas/:coach',
    loadChildren: () => import('./programas/programas.module').then( m => m.ProgramasPageModule)
  },
  {
    path: 'programas/:coach/:idPrograma',
    loadChildren: () => import('./detail/detail.module').then( m => m.DetailPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'cadastrar',
    loadChildren: () => import('./novo-usuario/novo-usuario.module').then( m => m.NovoUsuarioPageModule)
  },
  {
    path: 'agradecimento',
    loadChildren: () => import('./agradecimento/agradecimento.module').then( m => m.AgradecimentoPageModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)
  },
  {
    path: 'purchase/:coach/:idPrograma',
    loadChildren: () => import('./purchase/purchase.module').then( m => m.PurchasePageModule)
  },
  {
    path: 'my-programs',
    loadChildren: () => import('./my-programs/my-programs.module').then( m => m.MyProgramsPageModule)
  },
  {
    path: 'novo-programa',
    loadChildren: () => import('./novo-programa/novo-programa.module').then( m => m.NovoProgramaPageModule)
  },
  {
    path: 'my-programs-coach',
    loadChildren: () => import('./my-programs-coach/my-programs-coach.module').then( m => m.MyProgramsCoachPageModule)
  },
  {
    path: 'login-parceiro',
    loadChildren: () => import('./login-parceiro/login-parceiro.module').then( m => m.LoginParceiroPageModule)
  },
  {
    path: 'perfil-coach',
    loadChildren: () => import('./perfil-coach/perfil-coach.module').then( m => m.PerfilCoachPageModule)
  },
  {
    path: 'programa-treino',
    loadChildren: () => import('./programa-treino/programa-treino.module').then( m => m.ProgramaTreinoPageModule)
  },
  {
    path: 'novo-treino-programa',
    loadChildren: () => import('./novo-treino-programa/novo-treino-programa.module').then( m => m.NovoTreinoProgramaPageModule)
  },
  {
    path: 'treinos-programa',
    loadChildren: () => import('./treinos-programa/treinos-programa.module').then( m => m.TreinosProgramaPageModule)
  },
  {
    path: 'treino-programa-detalhe',
    loadChildren: () => import('./treino-programa-detalhe/treino-programa-detalhe.module').then( m => m.TreinoProgramaDetalhePageModule)
  },  {
    path: 'conclusao-modal',
    loadChildren: () => import('./conclusao-modal/conclusao-modal.module').then( m => m.ConclusaoModalPageModule)
  }

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
